<script lang="ts">
  import Tab from "../../components/Tab/Tab.svelte";
  import Tabs from "../../components/Tab/Tabs.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import CustomerDetailPageAddressFragment from "./CustomerDetailPageAddressFragment.svelte";
  import CustomerDetailPageCod317Fragment from "./CustomerDetailPageCod317Fragment.svelte";
  import CustomerDetailPageGeneralFragment from "./CustomerDetailPageGeneralFragment.svelte";
  import CustomerDetailPageLogotypeFragment from "./CustomerDetailPageLogotypeFragment.svelte";

  enum CustomerPage {
    General = 1,
    Addresses,
    Cod317,
    Logotypes,
  }

  export let oid: number;
  export let currentTab: CustomerPage = CustomerPage.General;
</script>

<MainLayout>
  <Tabs>
    <Tab
      label="Generale"
      active={currentTab == CustomerPage.General}
      on:click={(_) => {
        currentTab = CustomerPage.General;
      }}
    />

    {#if oid > 0}
      <Tab
        label="Indirizzi"
        active={currentTab == CustomerPage.Addresses}
        on:click={(_) => {
          currentTab = CustomerPage.Addresses;
        }}
      />

      <Tab
        label="Codici 317"
        active={currentTab == CustomerPage.Cod317}
        on:click={(_) => {
          currentTab = CustomerPage.Cod317;
        }}
      />

      <Tab
        label="Loghi"
        active={currentTab == CustomerPage.Logotypes}
        on:click={(_) => {
          currentTab = CustomerPage.Logotypes;
        }}
      />
    {/if}
  </Tabs>

  {#if currentTab == CustomerPage.General}
    <CustomerDetailPageGeneralFragment {oid} />
  {/if}

  {#if currentTab == CustomerPage.Addresses}
    <CustomerDetailPageAddressFragment customerId={oid} />
  {/if}

  {#if currentTab == CustomerPage.Cod317}
    <CustomerDetailPageCod317Fragment customerId={oid} />
  {/if}

  {#if currentTab == CustomerPage.Logotypes}
    <CustomerDetailPageLogotypeFragment customerId={oid} />
  {/if}
</MainLayout>
